<template>
  <div class="sub underline popover-hover">
    <div class="popover-nav">(說明)</div>
    <div class="popover">
      <component :is="renderMatchedComponent(paymentType)"></component>
    </div>
  </div>
</template>
<script>
import { paymentEnum } from '@/constant/payment-info';
import ApplePay from '@/components/desktop/step1/payment-method/common/pop-over-items/ApplePay.vue';
import EasyPay from '@/components/desktop/step1/payment-method/common/pop-over-items/EasyPay.vue';
import Jkos from '@/components/desktop/step1/payment-method/common/pop-over-items/Jkos.vue';
import Pi from '@/components/desktop/step1/payment-method/common/pop-over-items/Pi.vue';
import PlusPay from '@/components/desktop/step1/payment-method/common/pop-over-items/PlusPay.vue';
import PxPay from '@/components/desktop/step1/payment-method/common/pop-over-items/PxPay.vue';
import TaiwanPay from '@/components/desktop/step1/payment-method/common/pop-over-items/TaiwanPay.vue';
import Zingala from '@/components/desktop/step1/payment-method/common/pop-over-items/Zingala.vue';
import IPassMoneyPay from '@/components/desktop/step1/payment-method/common/pop-over-items/IPassMoneyPay.vue';

const props = {
  paymentType: Number,
};

export default {
  name: 'pop-over',
  props,
  methods: {
    renderMatchedComponent(paymentType) {
      const {
        jkosPayment,
        PiPayment,
        TWPayment,
        PlusPayPayment,
        EasyPayPayment,
        IPassMoneyPayment,
        ApplePayPayment,
        ZingalaPayment,
        PxPayPayment,
      } = paymentEnum;
      const map = new Map([
        [jkosPayment, Jkos],
        [PiPayment, Pi],
        [TWPayment, TaiwanPay],
        [PlusPayPayment, PlusPay],
        [PxPayPayment, PxPay],
        [EasyPayPayment, EasyPay],
        [IPassMoneyPayment, IPassMoneyPay],
        [ApplePayPayment, ApplePay],
        [ZingalaPayment, Zingala],
      ]);
      return map.get(paymentType);
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 1201px) {
  .sub .popover {
    width: 180px;
    left: 0px;
  }
}
@media screen and (max-width: 1200px) {
  .sub .popover {
    width: 160px;
    left: -50px;
  }
}
</style>
